import React from 'react'
import { useRef } from 'react';
import Draggable from 'react-draggable';
import CustomSelect from '../../Components/CustomSelect';
import { useState } from 'react';
import { useEffect } from 'react';
import { axiosInstance } from '../../Helpers/axiosInstance';

export default function PeopleModal({ selectedUnit, setSelectedUnit, editing, setEditing, setShouldUpdate }) {
        const nodeRef = useRef(null)
        const [rang, setRang] = useState("")
        const [position, setPosition] = useState("")
        const [fullName, setFullName] = useState("")
        const [birthday, setBirthday] = useState("")
        const [conscription, setConscription] = useState("")
        const [milCommissariat, setMilCommissariat] = useState("")
        const [address, setAddress] = useState("")
        const [type, setType] = useState("haveTo")
        const [special, setSpecial] = useState("2.1")
        const [battalion, setBattalion] = useState("")
        const [battalions, setBattalions] = useState([])
        const [company, setCompany] = useState("")
        const [companies, setCompanies] = useState([])
        const [platoon, setPlatoon] = useState("")
        const [platoons, setPlatoons] = useState([])
        const [weapons, setWeapons] = useState([])
        const [weapon, setWeapon] = useState("")
        const [weaponNumber, setWeaponNumber] = useState("")

        const rangList = ["կուրսանտ", "շ-ն", "եֆր․", "կրտ․ ս-տ", "ս-տ", "ավ․ ս-տ", "ավագ", "ենթ․","ավ․ ենթ․", "լ-տ", "ավ․ լ-տ", "կ-ն․", "մ-ր", "փ/գ-տ", "գ-տ", "գեն․ մ-ր", "գեն․ լ-տ", "գեն գ-տ"]
        

        useEffect(() => {
            setBattalions(selectedUnit?.unit_battalions || [])
            setCompanies(selectedUnit?.unit_companies || [])
            setPlatoons(selectedUnit?.unit_platoons || [])
            if(editing){
                setFullName(editing.full_name);
                setBirthday(editing.birthday.slice(0, 10));
                setPosition(editing.position);
                setRang(editing.rang);
                setConscription(editing.conscription);
                setMilCommissariat(editing.mil_commissariat);
                setAddress(editing.address);
                setType(editing.type);
                setSpecial(editing.special);
                setWeapon(editing.weapon);
                setWeaponNumber(editing.weapon_number);
                setPlatoon(editing.platoon);
                setCompany(editing.company);
                setBattalion(editing.battalion);
            }
        }, [])

        useEffect(() => {
                (async() => {
                    const weapons = await axiosInstance.get('admin/weapons')
                    if(weapons.status){
                        setWeapons(weapons.data.data)
                    }
                })()
        }, [])


        const onClose = () => {
            setSelectedUnit(null);
            setEditing(null);
        }

        const handleAddPeople = async () => {
            const response = await axiosInstance.post('admin/people', {
                full_name:fullName,
                birthday,
                position,
                rang,
                conscription,
                mil_commissariat: milCommissariat,
                address,
                type,
                special,
                weapon: weapon.endsWith(", ") ? weapon.slice(0, -2) : weapon,
                weapon_number: weaponNumber,
                unit: selectedUnit?._id,
                platoon,
                company,
                battalion
            });
            if (response.data.status) {
                onClose();
                setShouldUpdate(prev => !prev);
            }
        }

        const handleEditPeople = async () => {
            const response = await axiosInstance.put(`admin/people/${editing._id}`, {
                full_name:fullName,
                birthday,
                position,
                rang,
                conscription,
                mil_commissariat: milCommissariat,
                address,
                type,
                special,
                weapon: weapon.endsWith(", ") ? weapon.slice(0, -2) : weapon,
                weapon_number: weaponNumber,
                unit: selectedUnit?._id,
                platoon,
                company,
                battalion
            });
            if (response.data.status) {
                onClose();
                setShouldUpdate(prev => !prev);
            }
        }

    
  return (
    <div className="fixed top-0 left-0 w-screen h-screen bg-black/50 flex justify-center items-center" onClick={onClose}>
        <Draggable nodeRef={nodeRef} bounds='parent' cancel='.no-drag'>
            <div ref={nodeRef} className='max-w-[90%] max-h-[90%] bg-white rounded-lg p-4' onClick={(e) => e.stopPropagation()}>
                <h3 className='text-lg mb-4 text-center'>Զինծառայողի տվյալներ</h3>
                <div  className='grid grid-cols-2 gap-4' >
                    <div className='relative no-drag'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="name">Անուն/Ազգանուն/Հայրանուն</label>
                        <input className='border border-gray-500 rounded-md p-2' id="name" type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} />
                    </div>
                    <div className='no-drag'>
                        <CustomSelect 
                            defaultValueForInput={rang}
                            options={rangList?.map((el,i) => <option key={i} value={el}>{el}</option>)}
                            callback={setRang}
                            label="Զինկոչում"
                        />
                    </div>
                    <div className='relative no-drag'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="birthday">Ծննդյան տարեթիվ</label>
                        <input type="date" id="birthday" className='border border-gray-500 rounded-md p-2 w-full' value={birthday} onChange={(e) => setBirthday(e.target.value)} />
                    </div>
                    <div className='relative no-drag'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]" htmlFor="position">Պաշտոն</label>
                        <input className='border border-gray-500 rounded-md p-2' id="position" type="text" value={position} onChange={(e) => setPosition(e.target.value)} />
                    </div>
                     <div className='no-drag'>
                        <CustomSelect 
                            defaultValueForInput={battalion ? battalion.battalion_number + " " + battalion.battalion_name : ""}
                            options={battalions?.map((el,i) => <option key={el._id} value={el._id}>{el.battalion_number + " " + el.battalion_name}</option>)}
                            callback={setBattalion}
                            label="Գումարտակ"
                        />
                    </div>
                    <div className='no-drag'>
                        <CustomSelect 
                            defaultValueForInput={company ? company.company_number : ""}
                            options={companies?.filter(el => el.company_battalion === battalion).map((el,i) => <option key={el._id} value={el._id}>{el.company_number}</option>)}
                            callback={setCompany}
                            label="Վաշտ"
                        />
                    </div>
                     <div className='no-drag'>
                        <CustomSelect 
                            defaultValueForInput={platoon ? platoon.platoon_number : ""}
                            options={platoons?.filter(el => el.platoon_company === company && el.platoon_battalion === battalion).map((el,i) => <option key={el._id} value={el._id}>{el.platoon_number}</option>)}
                            callback={setPlatoon}
                            label="Դասակ"
                        />
                    </div>
                    <div className='relative no-drag'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="conscription">Զորակոչ</label>
                        <input type="text" id="conscription" className='border border-gray-500 rounded-md p-2 w-full' value={conscription} onChange={(e) => setConscription(e.target.value)} />
                    </div>
                    <div >
                        <div onChange={(e) => e.target.name === "stype" && setType(e.target.value)} className='text-sm'>
                            <div>
                                <input type="radio" id='temp' name="stype" value={"haveTo"} defaultChecked={type === "haveTo"}/> 
                                <label htmlFor='temp' className='ml-2 cursor-pointer'>Ժամկետային</label>
                            </div>
                            <div>
                                <input type="radio" id='contract' name="stype" value={"contract"} defaultChecked={type === "contract"}/>
                                <label htmlFor='contract' className='ml-2 cursor-pointer'>Պայմանագրային</label>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p className='text-sm'>Առանձնահատուկ</p>
                        <div onChange={(e) => e.target.name === "special_radio" && setSpecial(e.target.value)} className='text-sm flex justify-between'>
                            <div>
                                <input type="radio" id='2.1' name="special_radio" value={"2.1"} defaultChecked={special === "2.1"}/> 
                                <label htmlFor='2.1' className='ml-2 cursor-pointer'>2.1</label>
                            </div>
                            <div>
                                <input type="radio" id='2.2' name="special_radio" value={"2.2"} defaultChecked={special === "2.2"}/>
                                <label htmlFor='2.2' className='ml-2 cursor-pointer'>2.2</label>
                            </div>
                            <div>
                                <input type="radio" id='3.1' name="special_radio" value={"3.1"} defaultChecked={special === "3.1"}/>
                                <label htmlFor='3.1' className='ml-2 cursor-pointer'>3.1</label>
                            </div>
                            <div>
                                <input type="radio" id='3.2' name="special_radio" value={"3.2"} defaultChecked={special === "3.2"}/>
                                <label htmlFor='3.2' className='ml-2 cursor-pointer'>3.2</label>
                            </div>
                        </div>
                    </div>
                    <div className='relative no-drag'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="milCommissariat">Զինկոմիսարիատ</label>
                        <input type="text" id="milCommissariat" className='border border-gray-500 rounded-md p-2 w-full' value={milCommissariat} onChange={(e) => setMilCommissariat(e.target.value)} />
                    </div>
                    <div className='relative no-drag'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="address">Հասցե</label>
                        <input type="text" id="address" className='border border-gray-500 rounded-md p-2 w-full' value={address} onChange={(e) => setAddress(e.target.value)} />
                    </div>
                    <div className='no-drag'>
                        <div>
                            <CustomSelect 
                                defaultValueForInput={weapon}
                                options={weapons?.map((el,i) => <option key={el._id} value={el.weapon_name}>{el.weapon_name}</option>)}
                                callback={setWeapon}
                                label="Զենքի տեսակը"
                                many={true}
                            />
                        </div>
                    </div>
                        <div className='relative no-drag'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="weaponNumber">Զենքի համարը</label>
                        <input type="text" id="weaponNumber" className='border border-gray-500 rounded-md p-2 w-full' value={weaponNumber} onChange={(e) => setWeaponNumber(e.target.value)} />
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-2'>
                    <button className='bg-blue-500 text-white rounded-md p-2 mt-4 w-full' onClick={!editing ? handleAddPeople : handleEditPeople}>{!editing ? "Ավելացնել" : "Խմբագրել"}</button>
                    <button className='bg-gray-300 text-black rounded-md p-2 mt-4 w-full' onClick={onClose}>Փակել</button>
                </div>
            </div>
        </Draggable>
    </div>
  )
}

//  <div ref={nodeRef} className={BaseInfoStyles["adding-modal-container"]} onClick={(e) => e.stopPropagation()}>
//                         <div className={BaseInfoStyles["container"]}>
//                             <div className={BaseInfoStyles["left-container"]}> 
//                                 <div>
//                                     <Autocomplete
//                                         options={rangList.map((el) => el)}
//                                         value={obj.rang}
//                                         onChange={(event, newValue) => {
//                                             setObj({
//                                             ...obj,
//                                             rang: newValue || ''
//                                             });
//                                         }}
//                                         renderInput={(params) => (<InputWithOptions
//                                             inputProps={params.inputProps}
//                                             InputProps={params.InputProps}
//                                             inputRef={params.InputRef}
//                                             label="Զինկոչում"
//                                             validity="true"
//                                             value={obj.rang}
//                                             mr="20px"
//                                             name="rang"
//                                             onChange={(e) => {
//                                             const { name, value } = e.target;
//                                             setObj({
//                                                 ...obj,
//                                                 [name]: value
//                                             });
//                                             }}
//                                         />
//                                         )}
//                                         filterOptions={(props, state) => {
//                                             const filtered = props.filter((option) => option.toLowerCase().includes(obj.rang.toLowerCase()));
//                                             return filtered;
//                                         }
//                                         }
//                                         />
//                                     {/* <input list="rang-list" type="text" id="rang" name="rang" value={obj.rang} onChange={changeHandler} placeholder='Զինկոչում' />
//                                     <datalist id="rang-list">
//                                         {rangList.map((el,i) => <option key={i} value={el}>{el}</option>)}
//                                     </datalist> */}
//                                 </div>
//                                 <div>
//                                     <input type="text" id="conscription" name="conscription" value={obj.conscription} onChange={changeHandler} placeholder='Զորակոչ'/>
//                                 </div>
//                                 <div>
//                                     <input type="text" id="full_name" name="full_name" value={obj.full_name} onChange={changeHandler} placeholder='Անուն Ազգանուն Հայրանուն'/>
//                                 </div>
//                                 <div>
//                                     <input type="text" id="subvision" name="subvision" value={obj.subvision} onChange={changeHandler} placeholder='Ստորաբաժանում'/>
//                                 </div>
//                                 <div>
//                                     <input type="text" id="position" name="position" value={obj.position} onChange={changeHandler} placeholder='Պաշտոնը'/>
//                                 </div>
//                             </div>
//                             <div className={BaseInfoStyles["right-container"]}>
//                                 <div onChange={radioInput} className={BaseInfoStyles["radio-container"]}>
//                                     <div>
//                                         <input className={BaseInfoStyles["radio-input"]} type="radio" id='temp' name="rang" value={""} defaultChecked/> 
//                                         <p>Ժամկետային</p>
//                                     </div>
//                                     <div>
//                                         <input className={BaseInfoStyles["radio-input"]} type="radio" id='contract' name="rang" value={"(Պ)"}/>
//                                         <p>Պայմանագրային</p>
//                                     </div>
                                    
//                                 </div>
//                                 <div className={BaseInfoStyles["special-radio-container"]}>
//                                     <p className={BaseInfoStyles['asLable']}>Առանձնահատուկ</p>
//                                     <div onChange={radioInput} className={`${BaseInfoStyles['special-radio']} ${BaseInfoStyles["radio-container"]}`} style={{margin: "0"}}>
//                                         <div>
//                                             <input className={BaseInfoStyles["radio-input"]} type="radio" id='temp' name="special" value={"2.1"} defaultChecked/> 
//                                             <p>2.1 Կետ</p>
//                                         </div>
//                                         <div>
//                                             <input className={BaseInfoStyles["radio-input"]} type="radio" id='contract' name="special" value={"2.2"}/>
//                                             <p>2.2 Կետ</p>
//                                         </div>
//                                         <div>
//                                             <input className={BaseInfoStyles["radio-input"]} type="radio" id='temp' name="special" value={"3.1"}/> 
//                                             <p>3.1 Կետ</p>
//                                         </div>
//                                         <div>
//                                             <input className={BaseInfoStyles["radio-input"]} type="radio" id='contract' name="special" value={"3.2"}/>
//                                             <p>3.2 Կետ</p>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div>
//                                     <Autocomplete
//                                         options={weapons.map((el) => el.weapon_name)}
//                                         value={obj.gun_type}
//                                         onChange={(event, newValue) => {
//                                             setObj({
//                                             ...obj,
//                                             gun_type: newValue || ''
//                                             });
//                                         }}
//                                         renderInput={(params) => (<InputWithOptions
//                                             inputProps={params.inputProps}
//                                             InputProps={params.InputProps}
//                                             inputRef={params.InputRef}
//                                             label="Զենքի տեսակը"
//                                             mr="20px"
//                                             validity={true}
//                                             value={obj.gun_type}
//                                             name="gun_type"
//                                             onChange={(e) => {
//                                             const { name, value } = e.target;
//                                             setObj({
//                                                 ...obj,
//                                                 [name]: value
//                                             });
//                                             }}
//                                         />
//                                         )}
//                                         filterSelectedOptions
                                        
//                                         />
//                                     {/* <input type="text" id="gun_type" name="gun_type" list="weapon" value={obj.gun_type} onChange={changeHandler} placeholder='Զենքի տեսակը'  style={{
//                             borderColor: obj.gun_type && !validity ? 'red' : '',
//                             }}/> */}
//                                     {/* <datalist id="weapon">
//                                         {weapons.map((el,i) => <option key={i} value={el.weapon_name}>{el.weapon_name}</option>)}
//                                     </datalist> */}
//                                 </div>
//                                 <div>
//                                     <input type="text" id="gun_number" name="gun_number" value={obj.gun_number} onChange={changeHandler} placeholder='Զենքի համարը'/>
//                                 </div>
//                                 <div>
//                                     <input type="text" id="other_information" name="other_information" value={obj.other_information} onChange={changeHandler} placeholder='Այլ տվյալներ'/>
//                                 </div>
//                             </div>
//                         </div>
//                         <button disabled={disabled} className={`confirm-btn`} onClick={() => change ? changeArrayHandler() : fillArrayHandler()}>{change ? "Փոփոխել" : "Ավելացնել"}</button>
//                     </div>